import React from "react";

function TimeStamp({ timestamp }) {
    if (!timestamp) return <span className="text-slate-400">----</span>;

    const date = new Date(Number(timestamp));

    const persianDate = date.toLocaleDateString("fa-IR");

    const persianTime = date.toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
    });

    return (
        <span className="bg-slate-200 rounded text-slate-500 px-2">
            {persianTime} - {persianDate}
        </span>
    );
}

export default TimeStamp;


